export type NewsItem = {
  id: string;
  title: string;
  excerpt: string;
  image: string;
  link: string;
  reverse: boolean;
  tag?: string;
};

export const newsItems: NewsItem[] = [
  {
    id: "n1",
    title: "第二屆世界品牌大會暨「世界品牌日」落戶香港盛典 10 日在港舉行",
    excerpt:
      "新華社香港5月10日電——第二屆世界品牌大會暨「世界品牌日」落戶香港盛典10日在港舉行。香港特區行政長官李家超表示，香港將積極對接國家「十五五」規劃，強化品牌建設，推動香港建設世界品牌中心。此次大會由國際品牌科學院、粵港澳大灣區企業家聯盟及國際品牌網聯合主辦，旨在彰顯香港作為「世界品牌之都」及國際品牌中心的戰略定位。",
    image:
      "https://storage.readdy-site.link/project_files/d7d49463-cb3a-4e17-bed8-14db381c2d7e/2da27628-fca5-48a8-b43d-05e556859fd1_compressed_iabs_news_001.webp",
    link: "https://h.xinhuaxmt.com/vh512/share/13095998?docid=13095998&newstype=1001&d=135269e&channel=weixin",
    reverse: false,
    tag: "新聞報道",
  },
  {
    id: "n2",
    title: "行政長官李家超：香港將積極對接國家「十五五」規劃，強化品牌建設",
    excerpt:
      "他指出，在「一國兩制」下，香港擁有「背靠祖國、聯通世界」的獨特優勢，一直是國家企業和品牌走向全球的重要平臺。香港的智慧財產權制度廣受認同，為品牌的創立、管理、授權和商品化提供全面保障。特區政府會持續優化商標註冊制度，積極打擊侵權行為，保障品牌聲譽和消費者信心。",
    image:
      "https://storage.readdy-site.link/project_files/d7d49463-cb3a-4e17-bed8-14db381c2d7e/765319cf-3a60-4742-8feb-1b15dc58ebf1_compressed_2nd_cover_01.webp",
    link: "https://mp.weixin.qq.com/s/3mX9tu_GFXgoFo_PldwvbA",
    reverse: true,
    tag: "新聞報道",
  },
  {
    id: "n3",
    title: "「世界品牌日」落戶香港　全力建設「世界品牌之都」",
    excerpt:
      "第二屆世界品牌大會暨「世界品牌日」落戶香港盛典 10 日在港舉行。香港特別行政區行政長官李家超表示，香港將積極對接國家「十五五」規劃，強化品牌建設，推動香港建設世界品牌中心。此次大會由國際品牌科學院、粵港澳大灣區企業家聯盟及國際品牌網聯合主辦，旨在彰顯香港作為「世界品牌之都」及國際品牌中心的戰略定位。",
    image:
      "https://storage.readdy-site.link/project_files/d7d49463-cb3a-4e17-bed8-14db381c2d7e/db68fa5b-8d38-4dd8-bb25-c7a669523ed7_compressed_iabs_news_002.webp",
    link: "https://mp.weixin.qq.com/s/kjdFUqKHZJWdVGPy3sGQ3A",
    reverse: false,
    tag: "品牌網報道",
  },
  {
    id: "n4",
    title: "世界品牌日落戶香港　國際一流品牌專家及多國總領事親臨致賀",
    excerpt:
      "第二屆世界品牌大會暨世界品牌日落戶香港盛典於香港四季酒店舉行，會議宣布世界品牌大會香港宣言。行政長官李家超在視頻致辭中表示，今天是「世界品牌日」落戶香港、支持香港建設世界品牌中心的日子，別具意義。國家「十四五」規劃要求建設品牌強國，「一國兩制」下的香港擁有背靠祖國、聯通世界的獨特優勢。",
    image:
      "https://storage.readdy-site.link/project_files/d7d49463-cb3a-4e17-bed8-14db381c2d7e/9438e29b-5a7b-4a4e-b68d-7f1dd7bba10e_compressed_iabs_news_004.webp",
    link: "https://www.hkcd.com.hk/content_app/2026-05/10/content_8754314.html",
    reverse: true,
    tag: "新聞報道",
  },
  {
    id: "n5",
    title: "世界品牌日香港宣言——以品牌之力，共塑全球新秩序",
    excerpt:
      "由國際品牌科學院（IABS）主辦的第二屆世界品牌大會暨世界品牌日落戶香港盛典，已於2026年5月10日在香港盛大舉行。這場匯聚全球品牌精英與業界領袖的年度盛事，標誌著世界品牌日正式落戶香港，為這座國際金融與貿易中心注入了新的品牌發展動能。活動現場座無虛席，氣氛熱烈。",
    image:
      "https://storage.readdy-site.link/project_files/d7d49463-cb3a-4e17-bed8-14db381c2d7e/7c92937c-d3db-4c97-9b73-3d1e570d00ff_compressed_iabs_news_005.webp",
    link: "/news/conference",
    reverse: false,
    tag: "動態報道",
  },
  {
    id: "n6",
    title: "《世界稻米產區三十強》及《世界稻米地理標誌品牌百強》榜單發布",
    excerpt:
      "9月22日，由國際品牌科學院、華僑大學國際品牌研究院、國際品牌網、國際稻香米品牌中心及綏化市人民政府共同主辦的國際稻香米品牌大會暨慶安大米品牌發展交流會在黑龍江省慶安縣召開，來自全球的行業精英、專家學者、企業家及媒體代表等約300人齊聚一堂。",
    image:
      "https://readdy.ai/api/search-image?query=Golden%20ripe%20rice%20paddy%20field%20under%20warm%20autumn%20sunset%20light%2C%20elegant%20botanical%20close%20up%20of%20rice%20grains%2C%20cream%20and%20amber%20tones%2C%20refined%20editorial%20agriculture%20photography%2C%20soft%20natural%20lighting%2C%20high%20detail%20composition&width=1200&height=900&seq=iabs-news-06&orientation=landscape",
    link: "https://www.chinanationalbrand.org.cn/article/news/detail/id/42682",
    reverse: true,
    tag: "品牌榜單",
  },
  {
    id: "n7",
    title: "《2024 世界紡織服飾品牌強度評估結果》發布",
    excerpt:
      "9月20日，2024 紡織服裝品牌發展大會在常熟舉行。會上，國際品牌科學院發表了《2024 世界紡織服飾品牌強度評估結果》，全面盤點全球紡織服飾品牌的競爭力、可持續發展表現及國際化進程，為業界提供權威參考。",
    image:
      "https://readdy.ai/api/search-image?query=Luxurious%20textile%20and%20fabric%20swatches%20in%20cream%20burgundy%20and%20gold%20tones%20arranged%20artistically%20on%20warm%20wooden%20table%2C%20elegant%20editorial%20still%20life%20photography%2C%20soft%20natural%20window%20light%2C%20refined%20composition%20with%20subtle%20shadows&width=1200&height=900&seq=iabs-news-07&orientation=landscape",
    link: "https://www.chinanationalbrand.org.cn/article/news/detail/action/news/id/42672",
    reverse: false,
    tag: "品牌榜單",
  },
];